import cx from "classnames";
import React from "react";

import type { Asset, Fact } from "../../graphql-types";
import { useLexicon } from "../context/LexiconContext";
import Image from "./GatsbyImage";
import Heading from "./Heading";

import "../css/Facts.css";

type Props = {
  facts?: (Pick<Fact, "title" | "summary"> & {
    image: Pick<Asset, "description" | "gatsbyImageData">;
  })[];
};

const Facts: React.FC<Props> = ({ facts }) => {
  const lexicon = useLexicon();
  if (!facts || facts.length === 0) {
    return null;
  }

  return (
    <section className="container mx-auto cards">
      {lexicon.facts && (
        <Heading as="h2" className="p-10 text-2xl md:text-3xl md:p-14">
          {lexicon.facts}
        </Heading>
      )}
      <ul
        className={cx(
          "px-5 pb-5 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 lg:gap-5",
          {
            "mt-20 pt-5": !lexicon.facts,
          }
        )}
      >
        {facts.map(
          (
            { image: { description: alt, gatsbyImageData }, title, summary },
            i
          ) => {
            const titleText = title.trim();
            return (
              <li
                key={i}
                className="card-wrapper"
                style={{ textShadow: "0 2px 4px rgba(0, 0, 0, 0.6)" }}
              >
                <div className="card">
                  <div className="card--front">
                    <Image
                      image={gatsbyImageData}
                      alt={titleText}
                      className={cx({
                        "brightness-80": titleText,
                        "brightness-100": !titleText,
                      })}
                      aria-label={titleText}
                    />
                    {titleText && (
                      <span className="absolute inset-0 flex items-center justify-center px-2 text-xl font-bold leading-tight text-center text-white sm:text-2xl">
                        {titleText}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-center px-2 text-sm font-bold leading-tight text-center text-white card--back sm:text-2xl">
                    {summary}
                  </div>
                </div>
              </li>
            );
          }
        )}
      </ul>
    </section>
  );
};

export default Facts;
